import { useQuery, useMutation } from 'react-query';
import { useContext, useEffect, useState } from 'react';
import Button from '../ui/Button';
import './NewUser.scss';
import RoleSelector from './RoleSelector';
import { getHospitalslist, newUserCreation } from '../../api/superAPI';
import HospitalsSelector from '../adminDashboard/HospitalsSelector';
import AuthContext from '../../store/auth-context';

const NewUser = ({
    title,
    subtitle,
    onAccept,
    onDecline,
}) => {
    const hospitalQuery = useQuery({
		queryKey: ['hospital-list'],
		queryFn: getHospitalslist,
		staleTime: 3000000 //5 minutes to refetch
	});
    const mutation = useMutation({
        mutationFn: (userInfo) =>{newUserCreation(userInfo)},
        onSuccess: () => {
            onAccept();
        },
        onError:()=>{
        }
    });

    const authCtx = useContext(AuthContext);
    const [hospitalId, setHospitalId] = useState('');

    useEffect(() => {
        if (authCtx.userData?.hospital) {
            setHospitalId(authCtx.userData.hospital);
        }
    }, [authCtx.userData.hospital]);

    const [formValues, setFormValues] = useState({
        firstname: '',
        lastname: '',
        email: '',
        role: '',
    });

    const [isFormValid, setIsFormValid] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };
    const handleRoleChange = (selectedRole) => {
        setFormValues((prev) => ({ ...prev, role: selectedRole }));
    };

    useEffect(() => {
        const isValid = !Object.values(formValues).some((field) => !field?.trim())
        setIsFormValid(isValid);
    }, [formValues]);
    
    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const data = {
          firstname: formData.get('firstname'),
          lastname: formData.get('lastname'),
          email: formData.get('email'),
          role: formData.get('role'),
          hospital: hospitalId,
          department: formData.get('department'),
          phone: formData.get('phone'),
        };
        mutation.mutate(data);
      };
    if (hospitalQuery.isLoading) return 'Loading...';

        return (
            <form onSubmit={handleSubmit} className='new-hospital-container'>
            <section>
                <header>
                    <h2>{title}</h2>
                </header>
            </section>
            <div className='confirmation-Warning-subtitle'>
                <p>{subtitle}</p>
            </div>
            <div className='general-container'>
                <div className='title'>
                    <h2>Create New User</h2>
                </div>
                <div className='subtitle'>
                    <p>Please complete each input to add a new user</p>
                    <p>* Mandatory fields</p>
                </div>
                <div className='info-container'>
                    <div className='name-container'>
                        <div className='hospital-name'>
                            <p>First Name</p>
                            <input type="text" id='name' placeholder='Angela' required name='firstname' value={formValues.firstname} onChange={handleInputChange}/>
                        </div>
                        <div className='hospital-name'>
                            <p>Last Name</p>
                            <input type="text" id='lastname' placeholder='Smith' required name='lastname' value={formValues.lastname} onChange={handleInputChange}/>
                        </div>
                    </div>
            </div>
            <div className='info-container'>
                <div className='name-container'>
                    <div className='hospital-name'>
                        <p>Email *</p>
                        <input type='email' id='email' placeholder='example@gmail.com' required name='email' value={formValues.email} onChange={handleInputChange}/>
                    </div>
                    <div className='hospital-name'>
                        <p>Role *</p>
                        <RoleSelector selectedRole={formValues.role} onRoleChange={handleRoleChange}/>
                    </div>
                </div>
            </div>
            <div className='info-container'>
                <div className='name-container'>
                    <div className='hospital-name'>
                        <p>Phone Number</p>
                        <input type="text" id="phone" placeholder="+1 234 5678" name="phone" value={formValues.phone} onChange={handleInputChange}/>
                    </div>
                </div>
            </div>
            </div>

            <footer className='confirmation-Warning-controllers'>
                <Button
                    className='secondary-button'
                    onClick={onDecline}
                >
                    Cancel
                </Button>
                <Button
                    type='submit'
                    className='primary-button'
                    disabled={!isFormValid || mutation.isLoading}                   
                >
                    {!mutation.isLoading ? 'Create' : 'Loading'} 
                </Button>
            </footer>
        </form>
        );
};

export default NewUser;